export default __webpack_public_path__ + "static/media/walkthrough-4.2fa9c27e.png";